/**
 * Pagination component constructor
 * @constructor shared.stage.components.Pagination
 */
 fx.ns("shared.stage.components", class Pagination extends shared.stage.base.BaseComponent{
    
	constructor(component, model, parent, manual, commands)
	{
        super(component, model, parent, commands, manual);
        
        this.movableWhenActive = false;
        this.editable = false;
        this.movable = false;
        this.selectable = false;
        this.hoverable = !fx.browser.isMobile && !fx.browser.isTablet;
        this.innerDragEnabled = true;

        this._loadingFonts = [];

        this._acceptedSize = {width:0, height:0};

        this._loadFontTries = 0;

        this.lockOnlostBorder = true;

        Pagination.popupDisplayed = false;
    }
    
 
    /**************** Getters ****************/

    
    get MARGINS() { 
        return 10; 
    }

    get OFFEST() { 
        return 8.5; 
    }

    get font()
    {
        if (!this.data || !this.model)
            return "";   
            
        let font;

        font = this.model.fonts.getPaginationFonts().find({name : this.data.font_family});

        return font ? font : this.model.fonts.getPaginationFonts().getItemAt(0);
    }

    get fontFamily()
    {
        return this.font.id;
    }

    get textColor()
    {
        return this.model && this.model.creation ? this.model.creation.pagenumbers_textcolor : "";
    }

    get fontSizeLabel()
    {
        return this.model ? this.model.creation.pagenumbers_fontsize : "";
    }

    get alignEnabled()
    {
        return this.data.content_type != "slice-text";
    }

    get acceptedSize()
    {
        return this._acceptedSize;
    }

    get minComponentSize()
    {
        return  {
            height : this._acceptedSize ? this._acceptedSize.height : this.MARGINS*2,
            width : this.MARGINS*2
        }
    }

    /****************** Actions *********************/

    // Update Pagination 
    refresh(textcolor, bgcolor, fontsize, fontfamily, label)
    {
        let data = {};
        if(textcolor)
            data.text_color = textcolor;
        if(bgcolor)
            data.bgcolor = bgcolor;
        if(fontsize)
            data.font_size = fontsize;
        if(fontfamily)
            data.font_family = fontfamily;

        this.data.update(data);
        
        if (label)
            this._textArea.node.innerHTML = label;
    }
    
    onFontSizeInOut(value)
    {
        if (value == "up")
            this.onFontSizeUp();
        else
            this.onFontSizeDown();
    }

    onFontSizeUp()
    {
        this.model.event("pagination-font-size-up");
    }

    onFontSizeDown()
    {
        this.model.event("pagination-font-size-down");
    }

    onFontFamily(font)
    {
        this.model.event("pagination-fontfamily", font.name);
    }

    onTextColor(color)
    {
        this.model.customcolors.addColor( color, this.model.creation.id );
        this.model.event("pagination-text-color", color);
    }

    onBackgroundColor(color)
    {
        this.model.customcolors.addColor( color, this.model.creation.id );
        this.model.event("pagination-background-color", color);
    }

    updateCommands()
    {
        super.updateCommands();
    }

    /***************************************/

    create()
    {	
        super.create();
        this._textArea = new fx.components.Box();
        this.addChild( this._textArea );
    }
    
    onDataUpdated(action)
    {
        super.onDataUpdated(action);
        
        if (action.type == "init")
        {
            this.showActions = ((fx.browser.isMobile || fx.browser.isTablet) || this.data.content_type != "slice-text");
            this._textArea.attr("data-id", this.data.id);
            this._textArea.addClass("text");
            if (this.data.content)
                this._textArea.node.innerHTML = this.data.content;
            this._setDefaultStyle();
            this.data.event("text-size-updated", true);
        }
        if (action.impacts("text_color"))
            this._textArea.css({"color" : this.data.text_color});
        if (action.impacts("bgcolor"))
            this.css({"background-color" : this.data.bgcolor});
        if (action.impacts("font_size"))
        {
            this._textArea.css({"font-size": this.data.font_size});
            this.data.update({width: this.node.offsetWidth, height: this.node.offsetHeight});
        }
        if (action.impacts("font_family"))
            this._textArea.css({"font-family" : this.data.font_family});
        if (action.impacts("id"))
            this._textArea.attr("data-id", this.data.id);
    }

    onDisplayUpdated()
    {
        super.onDisplayUpdated();
        this._updateWarning();
    }

    displayPaginationPopup(){
        if(!Pagination.popupDisplayed){
			let popup = new common.popups.AddPaginationPopup();
            let scale = fx.graphics.getScale(this.parent.node);
			popup.options = { left : fx.dom.offset(this.node).left + fx.dom.outerWidth(this.node) * scale + 20, top:fx.dom.offset(this.node).top - (popup.contentHeight/2)+  (fx.dom.outerHeight(this.node)* scale / 2)};
            this.popup(popup);
            Pagination.popupDisplayed = true;
        }
    }

    setPosition(parentWidth, parentHeight){
		let x = 0;
		let y = 0;
		if(this.data.side === "left"){
			x = this.OFFEST;
			y = parentHeight-this.data.height -this.OFFEST;
		}
		else{
			x =  parentWidth-this.data.width -this.OFFEST;
			y =  parentHeight-this.data.height -this.OFFEST;
		}
		this.data.x = x;
		this.data.y = y;
	}

    /***************************************/

    _setDefaultStyle()
    {
        this.model.creation.pagenumbers_fontsize = this.model.creation.pagenumbers_fontsize > 6 || this.model.creation.pagenumbers_fontsize < 3 ? 4 : this.model.creation.pagenumbers_fontsize;
        if (this._textArea)
        {
            this._textArea.css({"color" : this.data.text_color});
            this.css({"background-color" : this.data.bgcolor});
            this._textArea.css({"font-family" : this.data.font_family});
            this._textArea.css({"font-size": this.data.font_size});
            this.data.update({width: this.node.offsetWidth, height: this.node.offsetHeight});
        }
    }

});
